
import { Options, Vue } from "vue-class-component";
import SideMenu from "@/components/WorkBench/SideMenu.vue";
import { store } from "@/store";
import {
  dispatchCreateProjectUser,
  dispatchDeleteProject,
  dispatchGetProjectUsers,
  dispatchRemoveProjectUser,
  dispatchUpdateProjectUser,
  dispatchUpdateProjectUsers,
} from "@/store/project/actions";
import { readMyProjects, readProjectUsers } from "@/store/project/getters";
import {
  compare,
  dateConversion,
  getLocalProject,
  regEnglishObj,
} from "@/utils";
import { readUserProfile } from "@/store/main/getters";
import { dispatchGetUserProfile } from "@/store/main/actions";
@Options({
  components: {
    SideMenu,
  },
})
export default class PipelineManage extends Vue {
  // 最后显示的数据
  public addMemberForm = {
    user: "",
    is_project_admin: false,
  };
  public new_addMemberForm = [];
  public dialogAddMemberFormVisible = false; // 新增弹出框是否可见
  public dialogUpdateProjectMemberVisible = false; //更新项目成员框
  public dialogAddMemberAdminFormVisible = false; //添加成员管理窗体
  public search = ""; //搜索
  public loading = false; //登录状态
  public admin_search = ""; //管理搜索
  public admin_loading = false; //管理登录
  public update_form_loading = false; //登录更新
  public ProjectFields = [
    //项目域
    { label: "项目英文代号", value: "project.project_key" },
    { label: "项目名称", value: "project.project_name" },
    { label: "关联用户", value: "user" },
    { label: "创建日期", value: "created_format" },
    { label: "创建者", value: "project.creator" },
  ];

  // 验证
  public re_english = (rule: any, value: any, callback: any) => {
    if (!regEnglishObj.test(value)) {
      callback(new Error("只支持英文、数字、下划线、英文句号、英文冒号及横线"));
    } else {
      callback();
    }
  };

  // 去重
  public is_exist = (rule: any, value: any, callback: any) => {
    if (
      this.nopendingMembers.filter((item) => item.user === value).length !== 0
    ) {
      callback(new Error("用户已在项目中"));
    } else {
      callback();
    }
  };

  // 验证
  public addMemberRules = {
    user: [
      { required: true, message: "请输入要添加的用户英文名", trigger: "blur" },
      { validator: this.re_english, trigger: "blur" },
      { validator: this.is_exist, trigger: "blur" },
    ],
  };

  // 选定的用户
  public nopendingMembers: any[] = [];

  public searchNoPendingMember = "";

  public handleRemoveMember(index: number, row: any) {
    this.nopendingMembers.splice(index, 1);
  }

  // 删除用户
  public async handleAdminRemoveMember(row: any) {
    this.admin_loading = true;
    await dispatchRemoveProjectUser(store, {
      id: row.id,
      project: row.project.id,
    });
    this.admin_loading = false;
  }

  // 判断是否是管理员
  public async admin_change(row: any) {
    const is_project_admin: boolean = (document.getElementById(
      "admin_change" + row.id
    ) as any).checked;
    const commitForm = {
      id: row.id,
      is_project_admin: is_project_admin,
      project: row.project.id,
      user: row.user,
    };
    this.admin_loading = true;
    await dispatchUpdateProjectUser(store, commitForm);
    this.admin_loading = false;
  }

  public nopendingChange(user: string) {
    const is_project_admin: boolean = (document.getElementById(
      "nopendingIsAdmin" + user
    ) as any).checked;
    const index: number = this.nopendingMembers.findIndex(
      (item) => item.user === user
    );
    this.nopendingMembers.splice(index, 1, {
      user: user,
      is_project_admin: is_project_admin,
    });
  }

  // 获取本地数据
  public localProject = Number(getLocalProject());
  public update_project_id = 0; //更新对象的id

  public async mounted() {
    this.admin_loading = true;
    this.loading = true;
    await dispatchGetUserProfile(store);
    // if (this.get_is_super) {
    //   await dispatchGetProjectUsers(store, this.localProject);
    // } else {
    //   await dispatchGetMyProjects(store);
    // }
    await dispatchGetProjectUsers(store, this.localProject);
    this.loading = false;
    this.admin_loading = false;
  }

  // 得到用户的信息
  public get get_project_users() {
    return readProjectUsers(store);
  }

  public GetMyProjects(search: string) {
    const my_projects: any[] = readMyProjects(store);
    for (let project of my_projects) {
      project.created_format = dateConversion(project.project.created);
      if (project.is_project_admin) {
        project.role = "项目管理员";
      } else {
        project.role = "项目成员";
      }
    }
    return my_projects.filter(
      (data) =>
        !data ||
        data.project.project_name
          ?.toString()
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        data.project.creator
          ?.toString()
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        data.project_key
          ?.toString()
          .toLowerCase()
          .includes(search.toLowerCase())
    );
  }

  submitAddMemberForm(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.dialogAddMemberFormVisible = false;
        if (
          this.addMemberForm.user.substr(
            this.addMemberForm.user.length - 1,
            1
          ) == ";"
        ) {
          this.addMemberForm.user = this.addMemberForm.user.substr(
            0,
            this.addMemberForm.user.length - 1
          );
        }
        let users1 = this.addMemberForm.user.split(";");
        let users = this.addMemberForm.user.split(";").map((item) => {
          return item.substring(0, item.lastIndexOf("("));
        });
        let userInfo: any;
        users.forEach((element) => {
          element == "" ? (userInfo = users1) : (userInfo = users);
        });
        userInfo.forEach((user: any) => {
          this.nopendingMembers.push({
            user: user,
            is_project_admin: this.addMemberForm.is_project_admin,
          });
        });
        this.dialogAddMemberFormVisible = false;
        this.dialogUpdateProjectMemberVisible = true;
      } else {
        alert("submit error");
        return false;
      }
    });
  }

  // 提交
  submitAddMemberAdminForm(formName: string, form: any) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (form.user.substr(form.user.length - 1, 1) == ";") {
        form.user = form.user.substr(0, form.user.length - 1);
      }
      let user1 = form.user.split(";");
      let users = form.user.split(";").map((item: any) => {
        return item.substring(0, item.lastIndexOf("("));
      });
      let userInfo: any;
      users.forEach((element: any) => {
        element == "" ? (userInfo = user1) : (userInfo = users);
      });
      let userInfo1: any = [];
      userInfo.forEach((v: any) => userInfo1.push(v.replace(" ", "")));

      if (valid) {
        this.dialogAddMemberAdminFormVisible = false;
        const commitForm = {
          user: userInfo1,
          is_project_admin: form.is_project_admin,
          project: this.localProject,
        };
        dispatchCreateProjectUser(store, commitForm);
      } else {
        alert("submit error");
        return false;
      }
    });
  }

  public addMember() {
    this.dialogAddMemberFormVisible = true;
    this.dialogUpdateProjectMemberVisible = false;
  }

  //156:新增按钮点击后显示新增窗口
  public addMemberAdmin() {
    this.dialogAddMemberAdminFormVisible = true;
  }

  returnAddMemberForm() {
    this.dialogAddMemberFormVisible = false;
    this.dialogUpdateProjectMemberVisible = true;
  }

  resetAddMemberForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
    this.dialogAddMemberFormVisible = false;
    this.dialogUpdateProjectMemberVisible = true;
  }
  // 返回
  resetAddMemberAdminForm(formName: string) {
    (this.$refs[formName] as any).resetFields();
    this.dialogAddMemberAdminFormVisible = false;
  }

  public async handleUpdateProjectMember(row: any) {
    this.update_form_loading = true;
    this.dialogUpdateProjectMemberVisible = true;
    await dispatchGetProjectUsers(store, row.project.id);
    this.nopendingMembers = readProjectUsers(store)
      .sort(compare("user"))
      .reverse();
    this.update_form_loading = false;
    this.update_project_id = row.project.id;
  }

  public closeDialogUpdateProjectMember() {
    this.nopendingMembers = [];
  }

  // 得到用户名
  public get get_username() {
    return readUserProfile(store)?.username;
  }

  // 判断是否是管理员
  public get get_is_super() {
    return readUserProfile(store)?.is_super;
  }
  // 判断是否是管理员
  public get get_is_super2() {
    let judge = true;
    let MyProject = readMyProjects(store).filter(
      (item: any) => item.project.id == this.localProject
    )[0]?.is_project_admin;
    if (readUserProfile(store)?.is_super) {
      judge = false;
    } else if (MyProject) {
      judge = false;
    } else {
      judge = true;
    }
    return judge;
  }

  // 管理成员表单提交
  public submitMemberManament() {
    const commitUserlist: any[] = [];
    this.nopendingMembers.forEach((item) => {
      commitUserlist.push({
        user: item.user,
        is_project_admin: item.is_project_admin,
      });
    });
    if (this.nopendingMembers.length === 0) {
      const is_delete_proejct: boolean = confirm(
        "您尝试移除项目所有成员, 请问您是否想要删除项目?"
      );
      if (is_delete_proejct) {
        this.dialogUpdateProjectMemberVisible = false;
        dispatchUpdateProjectUsers(store, {
          project: this.update_project_id,
          project_user: commitUserlist,
        });
        dispatchDeleteProject(store, { id: this.update_project_id });
      }
    } else {
      this.dialogUpdateProjectMemberVisible = false;
      dispatchUpdateProjectUsers(store, {
        project: this.update_project_id,
        project_user: commitUserlist,
      });
      alert("更新项目用户成功");
    }
  }
}
